<div class="list-wrapper">
  <editabel-treelist
    [apiName]="apiName"
    [label]="label"
    [name]="apiName"
    [inputEditorform]="inputEditorform"
    [IdName]="'Id'"
    reportName="GoodsGroup"
    pathPreFix="INV"
    [actions]="actions"
    [actionTregger]="onActionClick"
    [ParentIdName]="'ParentId'"
    [expandableField]="'Title'">
  </editabel-treelist>
</div>
